import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { api } from '@/api/client'
import type { User, Credentials } from '@/types/api'

export const useAuthStore = defineStore('auth', () => {
  const user = ref<User | null>(null)
  const token = ref<string | null>(localStorage.getItem('access_token'))
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  const isAuthenticated = computed(() => !!token.value)

  async function login(credentials: Credentials) {
    isLoading.value = true
    error.value = null
    
    try {
      const response = await api.login(credentials)
      token.value = response.access_token
      localStorage.setItem('access_token', response.access_token)
      
      // Parse user from JWT token (if backend includes it)
      // For now, just set username
      user.value = { 
        id: '1', 
        username: credentials.username 
      }
      
      return true
    } catch (err: any) {
      error.value = 'Wrong credentials'
      return false
    } finally {
      isLoading.value = false
    }
  }

  async function logout() {
    try {
      await api.logout()
    } catch {
      // Ignore logout errors
    } finally {
      user.value = null
      token.value = null
      localStorage.removeItem('access_token')
    }
  }

  function checkAuth() {
    const storedToken = localStorage.getItem('access_token')
    if (storedToken) {
      token.value = storedToken
      // In production, validate token with backend
      // For now, assume valid
      return true
    }
    return false
  }

  return {
    user,
    token,
    isLoading,
    error,
    isAuthenticated,
    login,
    logout,
    checkAuth
  }
})